var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFlag = function SvgFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7237 8.51633L12.7237 8.51632L12.7202 8.51287L11.9069 7.69954L11.8856 7.67823L11.8855 7.67558C11.8854 7.67331 11.8855 7.66441 11.8911 7.65042C11.8967 7.63639 11.9063 7.62097 11.9202 7.60709L12.7202 6.80709C13.4745 6.05277 14.1385 4.95604 13.6704 3.83081C13.2079 2.70836 11.9529 2.40665 10.8998 2.40665H4.87103C4.68631 1.78746 4.11063 1.33331 3.43311 1.33331C2.60749 1.33331 1.93311 2.00769 1.93311 2.83331V15.1666C1.93311 15.9923 2.60749 16.6666 3.43311 16.6666C4.25872 16.6666 4.93311 15.9923 4.93311 15.1666V12.9133H10.8998C11.9682 12.9133 13.1851 12.5898 13.6492 11.4788C14.1169 10.359 13.4697 9.26965 12.7237 8.51633Z",
    fill: "#00A3FF",
    stroke: "#121A1E",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag.62133fa4.svg";
export { ForwardRef as ReactComponent };